import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'edit-child-eligibility-status',
    templateUrl: './edit-child-eligibility-status.component.html',
    styleUrls: ['./edit-child-eligibility-status.component.scss']
})
export class EditChildEligibilityStatusComponent implements OnInit {
    @Input() studentId!: number;

    constructor() {}

    ngOnInit(): void {}
}
